import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { BobIntegrationConfig } from '@dadohr/shared/domainTypes/integrations/bob';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toBobConfigDoc = generateToDocFn<BobIntegrationConfig>();

const COLLECTION = FS.bobIntegrationConfig;
const collection = () => store().collection(COLLECTION);
export const bobConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toBobConfigDoc
);

export const useBobConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(bobConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<BobIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            apiKey: ''
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeBobConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};
